import React, { useState } from 'react';
import type { AdminTransferDetail } from '@platform/shared-types';
import { businessTransferApi } from '../../../services/businessTransferApi';
import { toastService } from '../../../services/toastService';
import { when } from '../format';

type P = { detail: AdminTransferDetail; canAct: boolean; onChange: (d: AdminTransferDetail) => void };

export default function VarSheetPanel({ detail, canAct, onChange }: P) {
  const v = detail.transfer.varSheet;
  const [mid, setMid] = useState(v?.mid || '');
  const [processor, setProcessor] = useState(v?.processor || '');
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const res = await businessTransferApi.varSheet(detail.transfer.transferId, { mid, processor, fileName: file?.name });
      if (file && res.uploadUrl) await fetch(res.uploadUrl, { method: 'PUT', headers: { 'Content-Type': 'application/pdf' }, body: file });
      onChange(res); toastService.success('VAR sheet recorded');
    } catch (e: any) { toastService.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col gap-2 text-sm">
      {v && <div className="text-stone-600">MID <b className="font-mono text-stone-900">{v.mid}</b> · {v.processor}{v.fileName ? ` · ${v.fileName}` : ''} · {when(v.uploadedAt)} by {v.uploadedBy}</div>}
      {canAct && (
        <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
          <input value={mid} onChange={(e) => setMid(e.target.value)} placeholder="MID" className="min-h-[44px] rounded-lg border border-stone-300 px-3 font-mono" />
          <input value={processor} onChange={(e) => setProcessor(e.target.value)} placeholder="Processor" className="min-h-[44px] rounded-lg border border-stone-300 px-3" />
          <label className="flex min-h-[44px] cursor-pointer items-center justify-center rounded-lg border border-dashed border-stone-300 px-3 text-xs text-stone-600">
            {file ? file.name : 'Attach VAR sheet (PDF)'}<input type="file" accept="application/pdf" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </label>
          <button type="button" disabled={busy || mid.trim().length < 4 || !processor.trim()} onClick={save} className="min-h-[44px] rounded-lg bg-[#DC143C] px-4 font-semibold text-white disabled:opacity-40 md:col-span-3">Save VAR sheet</button>
        </div>
      )}
    </div>
  );
}
